 /*
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @flow
 */

import {AbstractCrudObject} from './../abstract-crud-object';

/**
 * AdAccountASLSchedule
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */
export default class AdAccountASLSchedule extends AbstractCrudObject {
  static get Fields (): Object {
    return Object.freeze({
      ad_account: 'ad_account',
      id: 'id',
      time_created: 'time_created',
      time_updated: 'time_updated',
    });
  }

}
